import base_login_bgc from '../../public/image/base_login_bgc.png';

export interface SystemInfo {
  systemName: false | string;
  systemLogo: string;
  loginBgImage: string; // img url
}

export const defaultSystemInfo: SystemInfo = {
  systemName: 'Edatlink AI 智慧应用平台',
  systemLogo: 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg',
  loginBgImage: base_login_bgc,
}
